import React from 'react';
import { ReactComponent as CircleSvg } from '../../assets/svg/circle.svg';
import { ReactComponent as RightSvg } from '../../assets/svg/right.svg';

const ProgressHeader = ({step = 1}) => {

  return <div className="h-[50px] flex bg-[#013B02]">
    <div className='flex flex-1 justify-center items-center'>
      <span className='text-xl leading-none font-[700] text-[#3ADF53] p-[35px]'>Planogram Check</span>
    </div>
    <div className={`flex flex-1 items-center justify-center text-[14px] font-bold text-white ${step === 1 && 'progress-bar'}`}>
      {
        step === 1 ? <CircleSvg className="mr-3"></CircleSvg> :
          step > 1 ? <RightSvg className="mr-3"></RightSvg> : 
            <span className='text-[20px] mb-[5px] mr-3 opacity-50'>1.</span>
      }
      
      <span className={step === 1  ? 'text-white' : 'opacity-50'}>Customsize Your Shelf</span>
    </div>
    <div className={`flex flex-[1.5] items-center justify-center text-[14px] font-bold text-white ${step === 2 && 'progress-bar'}`}>
      {
        step === 2 ? <CircleSvg className="mr-3"></CircleSvg> :
          step > 2 ? <RightSvg className="mr-3"></RightSvg> : 
            <span className='text-[20px] mb-[5px] mr-3 opacity-50'>2.</span>
      }
      
      <span className={step === 2 ? 'text-white' : 'opacity-50'}>Add Your Packs&Design Your Shelf Layout</span>
    </div>
    <div className={`flex flex-1 items-center justify-center text-[14px] font-bold text-white ${step === 3 && 'progress-bar after:content-none'}`}>
      {
        step === 3 ? <CircleSvg className="mr-3"></CircleSvg> :
          step > 3 ? <RightSvg className="mr-3"></RightSvg> : 
            <span className='text-[20px] mb-[5px] mr-3 opacity-50'>3.</span>
      }
      
      <span className={step === 3 ? 'text-white' : 'opacity-50'}>Analysis&Comparison</span>
    </div>
  </div>;
};

export default ProgressHeader;